import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type UiState = {
  screen: 'main' | 'calculation';
  isShowPreloader: boolean;
};

const initialState: UiState = {
  screen: 'main',
  isShowPreloader: false,
};

export const info = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setScreen: (state, action: PayloadAction<UiState['screen']>) => {
      state.screen = action.payload;
    },
    setPreloader: (state, action: PayloadAction<UiState['isShowPreloader']>) => {
      state.isShowPreloader = action.payload;
    },
  },
});

export const { setPreloader, setScreen } = info.actions;
export default info.reducer;
